<template>
  <div id="ranking-board">
    <module-title></module-title>
    <div class="chart-con">

      <div class="chart-con-right">
        <div class="left-top">本月销售目标(元)：{{ target }}万</div>
        <div id="leftchart"></div>

      </div>
      <div class="chart-con-left">
        <div class="right-top">本月时间进度(天)：{{ day }}/{{ days }}</div>
        <div id="rightchart"></div>

      </div>
    </div>

  </div>

</template>

<script>
import moduleTitle from '@/components/Common/ModuleTitle.vue';


export default {
  name: 'MonthAch',
  components: {
    moduleTitle
  },
  data() {
    return {
      target: 0,
      showPercent: 0,
      chart: null, // 用于存储 ECharts 实例
      options: {
        tooltip: {
          trigger: 'item',
          position: function (point, params, dom, rect, size) {
            const obj = { top: 60 };
            const chartWidth = size.viewSize[0];
            const tooltipWidth = size.contentSize[0];
            if (point[0] < tooltipWidth / 2) {
              obj.left = 10;
            } else if (point[0] + tooltipWidth / 2 > chartWidth) {
              obj.left = chartWidth - tooltipWidth - 10;
            } else {
              obj.left = point[0] - tooltipWidth / 2;
            }
            return obj;
          },
          formatter: (params) => {
            const isCompleted = params.dataIndex === 1;
            const label = isCompleted ? '已完成金额' : '未完成金额';
            const color = isCompleted ? '#FFA837' : '#183294';
            const amount = isCompleted
              ? (params.data.showPercent || '0.00')
              : (this.target - (params.data.showPercent || 0)).toFixed(2);
            const percent = params.value;
            return `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:${color};"></span>${label}：${amount}万（${percent}%）`;
          }
        },
        // legend: {
        //   top: '5%',
        //   left: 'center'
        // },
        series: [
          {
            name: '销售目标进度',
            type: 'pie',
            radius: ['45%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              // 设置标签的样式
              rich: {
                name: {
                  fontSize: 16,
                  color: '#FFA837',
                  fontWeight: 'bold',
                  textAlign: 'center',
                },

                percent: {
                  fontSize: 12,
                  color: '#FFFFFF'

                }
              },
              // 使用 rich 中的样式
              formatter: function (params) {
                console.log('params', params);
                let showPercent = params.data.showPercent || '0.00';
                return `{percent|${params.value}%}\n{name|${showPercent}万}`;

              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 70,
                name: '未完成',
                itemStyle: {
                  color: '#183294'
                }
              },
              {
                value: 30,
                name: '已完成',
                showPercent: '0.00',
                itemStyle: {
                  color: '#FFA837'
                }
              },
            ]
          }
        ]
      },
      chart2: null, // 用于存储 ECharts 实例
      options2: {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `${params.name}：${params.value}%`;
          }
        },
        series: [
          {
            name: '任务完成度',
            type: 'pie',
            radius: ['45%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              // 设置标签的样式
              rich: {
                name: {
                  fontSize: 16,
                  color: '#0088F0',
                  fontWeight: 'bold',
                  textAlign: 'center',
                },

                percent: {
                  fontSize: 12,
                  color: '#FFFFFF'

                }
              },
              // 使用 rich 中的样式
              formatter: function (params) {
                return `{percent|${params.percent}%}\n{name|${params.name}}`;

              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 70,
                name: '未完成',
                itemStyle: {
                  color: '#183294'
                }
              },
              {
                value: 30,
                name: '已完成',
                itemStyle: {
                  color: '#0088F0'
                }
              },

            ]
          }
        ]
      },
      day: 0,
      days: 0
    }
  },
  mounted() {
    // 初始化 ECharts 实例
    this.chart = this.$echarts.init(document.getElementById('leftchart')); // 如果你选择了全局引入
    // 使用配置项和数据显示图表
    this.chart.setOption(this.options);

    //获取当月总天数
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    this.days = new Date(year, month, 0).getDate();
    this.day = date.getDate();
    let percent = (this.day / this.days * 100).toFixed(0);
    this.options2.series[0].data[1].value = percent;
    this.options2.series[0].data[1].name = this.day.toString() + '天';
    this.options2.series[0].data[0].value = 100 - percent;




    // 初始化 ECharts 实例
    this.chart2 = this.$echarts.init(document.getElementById('rightchart')); // 如果你选择了全局引入
    // 使用配置项和数据显示图表
    this.chart2.setOption(this.options2);
  },
  methods: {
    setData(data) {
      if (!data) return;
      console.log('Persent', data.Persent);
      if (data.AimAmount != null) {
        this.target = (Number(data.AimAmount) / 10000).toFixed(2);
      }
      let persent = Number(data.Persent) || 0;
      let saleAmount = Number(data.SaleAmount) || 0;
      this.options.series[0].data[1].value = (persent * 100).toFixed(0);
      this.options.series[0].data[1].name = saleAmount;
      this.options.series[0].data[0].value = persent > 1 ? 0 : (100 - persent * 100).toFixed(0);
      this.options.series[0].data[1].showPercent = (saleAmount / 10000).toFixed(2);
      this.chart.setOption(this.options);
    }
  },

}
</script>

<style lang="less" scoped>
#ranking-board {
  width: 100%;
  height: 100%;
  background: rgba(24, 50, 148, 0.30);
  border: 1px solid;
  border-image: linear-gradient(156deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 91%) 1 1;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

}

.chart-con {
  flex: 1;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.chart-con-left {
  flex: 1;
  width: 100%;
  height: 100%;
}

.chart-con-right {
  flex: 1;
  width: 100%;
  height: 100%;
}

.left-top {
  display: flex;
  width: 100%;
  height: 3.2vh;
  justify-content: center;
  align-items: center;
  flex-direction: row;

}

#leftchart {
  width: 100%;
  height: calc(100% - 4.2vh);
}

.right-top {
  display: flex;
  width: 100%;
  height: 3.2vh;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  font-size: 16px;

}

#rightchart {
  width: 100%;
  height: calc(100% - 3.2vh);
}
</style>